import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1bc8551f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "CreateCalculation" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-undo mr-2" }, null, -1))
const _hoisted_4 = { class: "mt-2 grid grid-cols-2 gap-3" }
const _hoisted_5 = { class: "flex items-center justify-end mt-3" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-check mr-2" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_the_button = _resolveComponent("the-button")!
  const _component_the_select = _resolveComponent("the-select")!
  const _component_the_input = _resolveComponent("the-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_page_title, { title: "Создание международной накладной" }),
      _createVNode(_component_the_button, {
        class: "second small text",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createTextVNode(" Назад ")
        ]),
        _: 1
      })
    ]),
    _createElementVNode("form", {
      class: "mt-6",
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.onSubmit && _ctx.onSubmit(...args)), ["prevent"]))
    }, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_the_select, {
          placeholder: "Номер накладной",
          value: _ctx.state.invoiceNumber,
          "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
          "is-invalid": _ctx.state_form$.invoiceNumber.$error,
          "validation-errors": _ctx.state_form$.invoiceNumber.$errors,
          loading: _ctx.data_state.invoices.is_loading,
          options: _ctx.data_state.invoices.list,
          failed: _ctx.data_state.invoices.is_failed,
          "error-text": "При получении списка накладных произошла ошибка",
          "infinite-scroll": "",
          label: "invoice_number",
          "select-by": "invoice_number",
          disabled: _ctx.progress.is_loading,
          onRefresh: _cache[2] || (_cache[2] = ($event: any) => (_ctx.loadInvoices(_ctx.data_state.invoices.pagination.current_page))),
          onLoadmore: _cache[3] || (_cache[3] = ($event: any) => (_ctx.loadMoreInvoices(_ctx.data_state.invoices.pagination.current_page + 1))),
          onOptionBySearch: _ctx.unshiftFindedInvoice,
          onSearch: _ctx.searchInvoice,
          onChange: _ctx.onInvoiceChange
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "disabled", "onOptionBySearch", "onSearch", "onChange"]),
        _createVNode(_component_the_select, {
          placeholder: "Компания",
          value: _ctx.state.companyId,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.companyId) = $event)),
          "is-invalid": _ctx.state_form$.companyId.$error,
          "validation-errors": _ctx.state_form$.companyId.$errors,
          loading: _ctx.data_state.companies.is_loading,
          options: _ctx.data_state.companies.list,
          failed: _ctx.data_state.companies.is_failed,
          "error-text": "При получении списка компаний произошла ошибка",
          "infinite-scroll": "",
          onRefresh: _ctx.loadCompanies,
          onSearch: _ctx.searchCompany,
          onOptionBySearch: _ctx.unshiftFindedCompany,
          disabled: !_ctx.state.invoiceNumber || _ctx.progress.is_loading
        }, null, 8, ["value", "is-invalid", "validation-errors", "loading", "options", "failed", "onRefresh", "onSearch", "onOptionBySearch", "disabled"]),
        _createVNode(_component_the_select, {
          placeholder: "Тип отправки",
          options: _ctx.SHIPMENT_TYPE_OPTIONS,
          value: _ctx.state.shipmentTypeId,
          "onUpdate:value": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.shipmentTypeId) = $event)),
          class: "mt-2",
          searchable: false,
          "is-invalid": _ctx.state_form$.shipmentTypeId.$error,
          "validation-errors": _ctx.state_form$.shipmentTypeId.$errors,
          disabled: !_ctx.state.invoiceNumber || _ctx.progress.is_loading
        }, null, 8, ["options", "value", "is-invalid", "validation-errors", "disabled"]),
        _createVNode(_component_the_input, {
          placeholder: "Цена за доставку",
          value: _ctx.state.deliveryCharge,
          "onUpdate:value": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.deliveryCharge) = $event)),
          disabled: !_ctx.state.invoiceNumber || _ctx.progress.is_loading,
          "is-invalid": _ctx.state_form$.deliveryCharge.$error,
          "validation-errors": _ctx.state_form$.deliveryCharge.$errors,
          maska: _ctx.PRICE_MASK
        }, null, 8, ["value", "disabled", "is-invalid", "validation-errors", "maska"])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_the_button, {
          type: "submit",
          class: "primary small",
          loading: _ctx.progress.is_loading
        }, {
          default: _withCtx(() => [
            _hoisted_6,
            _createTextVNode(" Создать ")
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ], 32)
  ]))
}